module.exports = __webpack_public_path__ + "static/media/waterdef_output.3364197d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WaterDefTool/waterdef_output.png
// module id = 1753
// module chunks = 0